import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_PROVIDER,
  DELETE_PROVIDER,
  GET_PROVIDERS,
  UPDATE_PROVIDER,
  UPDATE_PROVIDER_STATUS
} from "./actionTypes";

import {
  addProviderFail,
  addProviderSuccess,
  deleteProviderFail,
  deleteProviderSuccess,
  getProvidersFail,
  getProvidersSuccess,
  setState,
  updateProviderFail,
  updateProviderSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { providers, updateStatus } from "../../../helpers/adipiBackendUrl";
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchProviders({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, providers, params.toString());
    yield put(setState(false));
    yield put(getProvidersSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getProvidersFail(error));
  }
}

function* updateProvider({ payload: providerObj }) {
  try {
    const { id, recordStatus, ...rest } = providerObj;
    yield call(patchApiCall, `${providers}/${id}`, rest);
    const response = yield call(getTable, `${providers}/${providerObj.id}`);
    toast.success('Registro actualizado correctamente');
    yield put(updateProviderSuccess(response));
  } catch (error) {
    yield put(updateProviderFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateProviderStatus({ payload: providerObj }) {
  try {
    const { id } = providerObj;
    yield call(patchApiCall, `${providers}/${updateStatus}/${id}`, { recordStatus: providerObj.recordStatus });
    const response = yield call(getTable, `${providers}/${providerObj.id}`);
    yield put(updateProviderSuccess(response));
  } catch (error) {
    yield put(updateProviderFail(error));
  }
}

function* deleteProvider({ payload: providerObj }) {
  try {
    yield call(deleteApiCall, `${providers}/${providerObj.id}`);
    yield put(deleteProviderSuccess(providerObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteProviderFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingProvider({ payload: provider }) {
  try {
    const response = yield call(postApiCall, providers, provider);
    yield put(addProviderSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addProviderFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* providersSaga() {
  yield takeEvery(GET_PROVIDERS, fetchProviders);
  yield takeEvery(ADD_NEW_PROVIDER, postingProvider);
  yield takeEvery(UPDATE_PROVIDER, updateProvider);
  yield takeEvery(UPDATE_PROVIDER_STATUS, updateProviderStatus);
  yield takeEvery(DELETE_PROVIDER, deleteProvider);
}

export default providersSaga;
